import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";
import { ExternalLink, Download, FileText, Zap, Users, Target, Rocket, Shield } from "lucide-react";

const BroPaperSection = () => {
  const tokenomicsData = [
    { name: "Community Brodrop", percentage: 30, description: "Open mint, flat pricing", mood: "⚔️ Day-one chaos" },
    { name: "Commons Vault", percentage: 20, description: "Grants, tools, charity", mood: "🛠️ Public goods" },
    { name: "Liquidity Lock", percentage: 15, description: "SOL pair, LP burned", mood: "🔒 Trustless & forever" },
    { name: "Builder Guild", percentage: 15, description: "Pay devs & designers", mood: "👷 Skin-in-the-game" },
    { name: "Bro Distribution", percentage: 10, description: "Quests, airdrops", mood: "🎁 Random dopamine" },
    { name: "Meme Ops", percentage: 10, description: "CT raids, IRL stunts", mood: "📣 Megaphone" },
  ];

  const roadmapActs = [
    {
      act: "Act I",
      timeframe: "Now → Q3 2025",
      description: "Brodrop detonated. LP burned. Soakers 1.0 splashes across Telegram. Brosuit Society initiation. Launch Mobile App."
    },
    {
      act: "Act II", 
      timeframe: "Q4 2025",
      description: "Soakers 2.0 SDK ships—any crypto community can reskin & license the carnage + Dungeon Bros rogue-like launches."
    },
    {
      act: "Act III",
      timeframe: "Before Dec 31 2025", 
      description: "Acquire strategic minority stakes in 3 tech companies (Utility platforms in gaming, AI & Web3) First acquisition done already."
    },
    {
      act: "Act IV",
      timeframe: "H1 2026",
      description: "Fuse more acquisitions. Cross-game multiverse, MNFT Season β, first IRL 'Bro Summit.' Agentic framework for the Brosuit Society. Launch Bro L2 to support our ecosystem."
    },
    {
      act: "Act V",
      timeframe: "∞",
      description: "Community writers' room—plot twists voted on-chain."
    }
  ];

  const features = [
    {
      icon: <Zap className="h-6 w-6" />,
      title: "Bots & Mini-Apps",
      description: "BroRankBot, mod dashboards, analytics tools — $TOP1 is your key to functionality."
    },
    {
      icon: <Target className="h-6 w-6" />,
      title: "Games",
      description: "Soakers, Dungeon Bros — $TOP1 buys cosmetics, unlocks events, or levels up gameplay."
    },
    {
      icon: <Users className="h-6 w-6" />,
      title: "AI Agents",
      description: "Automation agents that can write proposals, draft meme copy, scout bounties, and handle DAO tasks."
    },
    {
      icon: <Shield className="h-6 w-6" />,
      title: "Community Perks",
      description: "Stake $TOP1 to unlock gated features, MNFT airdrops, treasury voting, and game upgrades."
    }
  ];

  return (
    <section id="bropaper" className="py-24 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-foreground mb-6">
            THE <span className="text-secondary">BROPAPER</span>
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-3xl mx-auto">
            Whitepaper vX+1 — "Feel Something" Edition
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button 
              size="lg" 
              className="bg-primary hover:bg-primary/90"
              onClick={() => window.open('/lovable-uploads/The BroPaper vX+1 --- _Feel Something_ Edition.pdf', '_blank')}
            >
              <Download className="mr-2 h-5 w-5" />
              Download Full Paper
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => window.open('/brotocol', '_self')}
            >
              <FileText className="mr-2 h-5 w-5" />
              View Interactive Version
            </Button>
          </div>
        </div>

        {/* TL;DR Section */}
        <Card className="mb-16 border-secondary/20">
          <CardHeader>
            <CardTitle className="text-secondary text-2xl">TL;DR — Read Me Like a Meme</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4 text-lg">
              <p className="text-foreground">🪙 Mint. Meme. Make history.</p>
              <p className="text-foreground">⚡ No kings. No VC leash. No ROI carrots.</p>
              <p className="text-foreground">🤝 Just a brotherhood that weaponizes late-night shitposts into on-chain artifacts and men's-mental-health impact.</p>
            </div>
          </CardContent>
        </Card>

        {/* Mission Statement */}
        <div className="text-center mb-16">
          <h3 className="text-3xl font-bold text-secondary mb-6">What is Bromentum?</h3>
          <p className="text-xl text-foreground max-w-4xl mx-auto leading-relaxed">
            A decentralized insurgency for men who are DONE playing NPC. Imagine ConstitutionDAO's flash-mob energy, 
            Nouns' art-as-governance, and Doge's irreverence—But elevated into one 24/7 Telegram tavern. 
            Build, ship, acquire, add value and help the collective grow in all aspects of life.
          </p>
          <Badge className="mt-6 bg-secondary text-secondary-foreground text-lg px-6 py-2">
            By the community, for the community
          </Badge>
        </div>

        {/* Tokenomics Section */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-secondary text-center mb-8">Tokenomics / "Royal Decree"</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {tokenomicsData.map((item, index) => (
              <Card key={index} className="border-secondary/20">
                <CardContent className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h4 className="font-semibold text-foreground">{item.name}</h4>
                    <Badge variant="secondary" className="text-lg font-bold">
                      {item.percentage}%
                    </Badge>
                  </div>
                  <p className="text-muted-foreground mb-2">{item.description}</p>
                  <p className="text-sm font-medium text-accent">{item.mood}</p>
                </CardContent>
              </Card>
            ))}
          </div>
          <Card className="border-secondary/20">
            <CardContent className="p-6 text-center">
              <p className="text-xl font-bold text-foreground mb-2">
                Supply hard-capped at 1B tokens
              </p>
              <p className="text-lg text-muted-foreground">
                2% transfer tax to fund community events and burn events
              </p>
            </CardContent>
          </Card>
        </div>

        {/* How $TOP1 Powers Ecosystem */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-secondary text-center mb-8">
            How $TOP1 Powers the Ecosystem
          </h3>
          <div className="text-center mb-8">
            <Badge className="bg-primary text-primary-foreground text-xl px-8 py-3">
              $TOP1 = Utility, Not Yield
            </Badge>
          </div>
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            {features.map((feature, index) => (
              <Card key={index} className="border-secondary/20">
                <CardContent className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className="text-secondary flex-shrink-0 mt-1">
                      {feature.icon}
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground mb-2">{feature.title}</h4>
                      <p className="text-muted-foreground">{feature.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
          <Card className="border-secondary/20">
            <CardContent className="p-6">
              <h4 className="text-xl font-bold text-foreground mb-4 text-center">The Ecosystem Loop</h4>
              <p className="text-center text-muted-foreground text-lg leading-relaxed">
                $TOP1 goes in → bots/games/agents light up → fees go to Vault → Vault funds growth → 
                new features launch → $TOP1 becomes more useful → repeat.
              </p>
              <p className="text-center text-accent font-medium mt-4">
                No staking APY. No passive emissions. Just real usage, real output, real utility.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* XP System */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-secondary text-center mb-8">
            XP ↔ $TOP1: The Two-Currency Engine
          </h3>
          <div className="grid md:grid-cols-2 gap-8">
            <Card className="border-secondary/20">
              <CardHeader>
                <CardTitle className="text-foreground">BroScore (XP) = Proof of Contribution</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3 text-muted-foreground">
                  <li>• Non-transferable reputation points</li>
                  <li>• Earned by playing, building, posting, raiding</li>
                  <li>• Convert XP → $TOP1 anytime (one-way only)</li>
                  <li>• Fair grind currency that can't be farmed</li>
                </ul>
              </CardContent>
            </Card>
            <Card className="border-secondary/20">
              <CardHeader>
                <CardTitle className="text-foreground">Task Marketplace</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3 text-muted-foreground">
                  <p>Both XP and $TOP1 can pay for work:</p>
                  <ul className="space-y-2 ml-4">
                    <li>• "Design art pack: 5,000 XP or 2,000 $TOP1"</li>
                    <li>• "Roast project xyz: 1,000 XP or 500 $TOP1"</li>
                    <li>• "Create AI videos: 3,000 XP or 1,000 $TOP1"</li>
                  </ul>
                  <p className="text-accent font-medium">XP = sweat. $TOP1 = fuel.</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Roadmap */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-secondary text-center mb-8">
            Roadmap | Movie Trailer Cut
          </h3>
          <div className="space-y-6">
            {roadmapActs.map((act, index) => (
              <Card key={index} className="border-secondary/20">
                <CardContent className="p-6">
                  <div className="flex flex-col md:flex-row md:items-center gap-4">
                    <div className="flex-shrink-0">
                      <Badge className="bg-primary text-primary-foreground text-lg px-4 py-2">
                        {act.act}
                      </Badge>
                    </div>
                    <div className="flex-shrink-0">
                      <Badge variant="outline" className="text-secondary border-secondary">
                        {act.timeframe}
                      </Badge>
                    </div>
                    <p className="text-foreground flex-1">{act.description}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Legal Disclaimer */}
        <Card className="border-destructive/20 bg-destructive/5">
          <CardHeader>
            <CardTitle className="text-destructive text-center">
              Legal Scroll (Dogecoin-Level Frankness)
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center">
            <p className="text-lg text-foreground mb-4">
              "$TOP1 is a participation relic with zero guaranteed value. If price chat is your love language, do it somewhere else."
            </p>
            <Badge className="bg-muted text-muted-foreground">
              Risk Matrix: Very Low on securities—utility framing, no promised ROI
            </Badge>
          </CardContent>
        </Card>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <h3 className="text-3xl font-bold text-secondary mb-6">Join the Brotherhood</h3>
          <p className="text-xl text-foreground mb-8 max-w-2xl mx-auto">
            You read this far—so the legend already has your fingerprints. Take the pen. Mint the key. 
            Let's carve our initials on-chain and call it BROMENTUM.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button 
              size="lg" 
              className="bg-primary hover:bg-primary/90"
              onClick={() => window.open('https://t.me/BroRankBot?start=initiation', '_blank')}
            >
              <Rocket className="mr-2 h-5 w-5" />
              Start Initiation
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => window.open('https://t.me/bromentumcommunity', '_blank')}
            >
              <ExternalLink className="mr-2 h-5 w-5" />
              Join Community
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BroPaperSection;